import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type SecurityFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const SecurityFilled = forwardRef<SVGSVGElement, SecurityFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(1.218679 0.5) scale(0.71875)">
        <path d="M29.4001 6.81806C29.3503 6.33756 29.1463 5.88506 28.8175 5.52598C28.4888 5.16689 28.0523 4.91983 27.5713 4.82049C25.5702 4.51138 23.5937 4.06432 21.6565 3.48263C19.7594 2.71818 17.9805 1.69656 16.3717 0.447501C15.9603 0.156544 15.4663 0 14.9594 0C14.4525 0 13.9585 0.156544 13.5471 0.447501C12.0241 1.83149 10.2045 2.86196 8.22223 3.46293C6.38679 4.20862 4.44788 4.67951 2.47024 4.85988C1.9809 4.93757 1.53378 5.17869 1.20429 5.54257C0.874796 5.90646 0.683083 6.37085 0.661475 6.85745C0.661475 6.85745 0.600098 11.8705 0.600098 16.2828C0.600098 24.2706 10.1926 32 14.9901 32C19.7863 32 27.917 26.5476 29.2172 16.4034C29.5429 10.412 29.3174 6.83776 29.3174 6.83776L29.4001 6.81683V6.81806ZM24.1767 12.988L14.1558 22.2743C13.7049 22.6965 13.016 22.7629 12.4899 22.4343L12.2268 22.214L6.6978 16.5634C6.4498 16.2987 6.31899 15.948 6.33415 15.5885C6.3493 15.229 6.50917 14.8902 6.77859 14.6465C7.04802 14.4028 7.40492 14.2743 7.7708 14.2892C8.13667 14.3041 8.48154 14.4612 8.72953 14.7259L13.2828 19.4189L22.3066 11.0311C22.4401 10.9104 22.5964 10.8168 22.7667 10.7555C22.9371 10.6942 23.118 10.6665 23.2992 10.6739C23.4804 10.6813 23.6584 10.7238 23.8229 10.7988C23.9875 10.8738 24.1353 10.9799 24.2581 11.1111C24.3809 11.2422 24.4762 11.3959 24.5386 11.5632C24.601 11.7306 24.6292 11.9083 24.6216 12.0864C24.614 12.2645 24.5709 12.4393 24.4945 12.601C24.4182 12.7627 24.3102 12.908 24.1767 13.0286V12.988Z" />
      </g>
    </svg>
  ),
);

SecurityFilled.displayName = 'SecurityFilled';

export default SecurityFilled;
